import { all, takeEvery } from 'redux-saga/effects';

import * as actionTypes from '../actions/actionTypes';
import * as armySagas from "./army";
import * as chatSagas from "./chat";
import * as generalsSagas from "./generals";
import * as governorateSagas from "./governorate";
import * as labyrinthSagas from "./labyrinth";
import * as magicSagas from "./magic";
import * as mailSagas from "./mail";
import * as marketplaceSagas from "./marketplace";
import * as profilesSagas from "./profiles";
import * as technologySagas from "./technology";
import * as thievesSagas from "./thieves";
import * as toolsSagas from "./tools";
import * as uiSagas from "./ui";

export function* watchGovernorate() {
  yield all([
    takeEvery(actionTypes.INIT_STATE, governorateSagas.initGovernorateSaga),
    takeEvery(actionTypes.SET_NOTIFICATION_READ,
      (action: any) => governorateSagas.setNotificationReadSaga(action)),
    takeEvery(actionTypes.SET_NOTIFICATION_SEEN, governorateSagas.setNotificationsSeenSaga),
    takeEvery(actionTypes.GET_NEWS, governorateSagas.getNewsSaga),
    takeEvery(actionTypes.MOVE_CALENDAR,
      (action: any) => governorateSagas.moveCalendarSaga(action)),
    takeEvery(actionTypes.NEXT_TURN, governorateSagas.nextTurnSaga),
    takeEvery(actionTypes.LEAVE_ALLIANCE,
      (action: any) => profilesSagas.leaveAllianceSaga(action)),
    takeEvery(actionTypes.FOUND_ALLIANCE,
      (action: any) => profilesSagas.foundAllianceSaga(action)),
    takeEvery(actionTypes.APPLY_ALLIANCE,
      (action: any) => profilesSagas.applyAllianceSaga(action)),
    takeEvery(actionTypes.CANCEL_APPLICATION,
      (action: any) => profilesSagas.cancelApplicationSaga(action)),
    takeEvery(actionTypes.ACCEPT_APPLICATION,
      (action: any) => profilesSagas.acceptApplicationSaga(action)),
    takeEvery(actionTypes.EXPEL_MEMBER,
      (action: any) => profilesSagas.expelMemberSaga(action)),
    takeEvery(actionTypes.TOGGLE_WAR_APPLICATION,
      (action: any) => profilesSagas.toggleWarApplicationSaga(action)),
    takeEvery(actionTypes.TOGGLE_COMMANDER,
      (action: any) => profilesSagas.toggleCommanderSaga(action)),
    takeEvery(actionTypes.HANDOVER_EMPEROR,
      (action: any) => profilesSagas.handoverEmperorSaga(action)),
    takeEvery(actionTypes.EDIT_NOTE,
      (action: any) => profilesSagas.editNoteSaga(action)),
    takeEvery(actionTypes.ABDICATE,
      (action: any) => profilesSagas.abdicateSaga(action)),
    takeEvery(actionTypes.HIRE_POP,
      (action: any) => governorateSagas.togglePopSaga(action)),
    takeEvery(actionTypes.RELEASE_POP,
      (action: any) => governorateSagas.togglePopSaga(action)),
    takeEvery(actionTypes.BUILD_BUILDING,
      (action: any) => governorateSagas.buildBuildingSaga(action)),
    takeEvery(actionTypes.UPGRADE_BUILDING,
      (action: any) => governorateSagas.buildBuildingSaga(action)),
    takeEvery(actionTypes.DEMOLISH_BUILDING,
      (action: any) => governorateSagas.demolishBuildingSaga(action)),
    takeEvery(actionTypes.CANCEL_BUILDING_DEMOLITION,
      (action:any) => governorateSagas.cancelBuildingDemolitionSaga(action)),
    takeEvery(actionTypes.REPAIR_BUILDING,
      (action:any) => governorateSagas.repairBuildingSaga(action)),
    takeEvery(actionTypes.INVEST_TECH_POINT,
      (action:any) => technologySagas.investTechPointSaga(action)),
    takeEvery(actionTypes.INVEST_SKILL_POINT,
      (action:any) => generalsSagas.investSkillPointSaga(action)),
    takeEvery(actionTypes.INVEST_STRENGTH_BONUS,
      (action:any) => generalsSagas.investStrengthBonusSaga(action)),
    takeEvery(actionTypes.INVEST_TECH_POINT_XP,
      (action:any) => generalsSagas.investTechPointSagaXP(action)),
    takeEvery(actionTypes.CHOOSE_TREASURE,
      (action:any) => labyrinthSagas.chooseTreasureSaga(action)),
    takeEvery(actionTypes.QUEST_LIST_VIEWED,
      () => governorateSagas.questListViewedSaga()),
    takeEvery(actionTypes.FINISH_QUEST,
      action => governorateSagas.finishQuestSaga(action)),
    takeEvery(actionTypes.BOOST_HAPPINESS,
      action => governorateSagas.boostHappinessSaga(action)),
    takeEvery(actionTypes.RECRUIT_UNIT,
      (action:any) => armySagas.recruitUnitSaga(action)),
    takeEvery(actionTypes.RELEASE_UNIT,
      (action:any) => armySagas.releaseUnitSaga(action)),
    takeEvery(actionTypes.OCCUPY_BANNER,
      (action:any) => armySagas.occupyPositionSaga(action)),
    takeEvery(actionTypes.ADD_BANNER_UNITS,
      (action:any) => armySagas.addBannerUnitsSaga(action)),
    takeEvery(actionTypes.REMOVE_BANNER_UNITS,
      (action:any) => armySagas.removeBannerUnitsSaga(action)),
    takeEvery(actionTypes.ASSIGN_BANNER_GENERAL,
      (action:any) => armySagas.assignBannerGeneralSaga(action)),
    takeEvery(actionTypes.RELEASE_BANNER_GENERAL,
      (action:any) => armySagas.releaseBannerGeneralSaga(action)),
    takeEvery(actionTypes.SET_BATTLE_TACTICS,
      (action:any) => armySagas.setBattleTacticsSaga(action)),
    takeEvery(actionTypes.LEAVE_BANNER,
      (action:any) => armySagas.leavePositionSaga(action)),
    takeEvery(actionTypes.INVEST_MAGIC_RESEARCH,
      (action: any) => magicSagas.investMagicResearchSaga(action)),
    takeEvery(actionTypes.LEARN_SPELL,
      action => magicSagas.learnSpellSaga(action)),
    takeEvery(actionTypes.UPGRADE_SPELL,
      action => magicSagas.upgradeSpellSaga(action)),
    takeEvery(actionTypes.DISPERSE_SPELL,
      action => magicSagas.disperseSpellSaga(action)),
    takeEvery(actionTypes.CAST_SPELL,
      action => magicSagas.castSpellSaga(action)),
    takeEvery(actionTypes.PLAN_SPELL,
      action => magicSagas.planSpellSaga(action)),
    takeEvery(actionTypes.UPDATE_SPELL,
      action => magicSagas.updateSpellSaga(action)),
    takeEvery(actionTypes.TOGGLE_MAGIC_PLAN,
      action => magicSagas.toggleMagicPlanSaga(action)),
    takeEvery(actionTypes.SET_MAGIC_MODE,
      action => magicSagas.setMagicModeSaga(action)),
    takeEvery(actionTypes.SET_AUTOCAST,
      action => magicSagas.setAutocastSaga(action)),
    takeEvery(actionTypes.SEND_THIEVES,
      action => thievesSagas.sendThievesSaga(action)),
    takeEvery(actionTypes.CANCEL_THIEVES,
      action => thievesSagas.cancelThievesSaga(action)),
    takeEvery(actionTypes.PURCHASE_TOOL,
      action => toolsSagas.purchaseToolsSaga(action)),
    takeEvery(actionTypes.GET_CHAT_POSTS, action => chatSagas.getChatPostsSaga(action)),
    takeEvery(actionTypes.SEND_CHAT_POST, action => chatSagas.sendPostSaga(action)),
    takeEvery(actionTypes.DELETE_CHAT_POSTS, action => chatSagas.deletePostsSaga(action)),
    takeEvery(actionTypes.GET_MAIL_POSTS, action => mailSagas.getMailPostsSaga(action)),
    takeEvery(actionTypes.SEND_MAIL_POST, action => mailSagas.sendPostSaga(action)),
    takeEvery(actionTypes.DELETE_MAIL_POSTS, action => mailSagas.deletePostsSaga(action)),
  ]);
}

export function* watchUI() {
  yield all([
    // takeEvery(actionTypes.OPEN_CONTENT_POPUP,
    //   (action: any) => uiSagas.openContentPopupSaga(action)),
    // takeEvery(actionTypes.CLOSE_CONTENT_POPUP, uiSagas.closeContentPopupSaga),
    // takeEvery(actionTypes.OPEN_DIALOG, (action: any) => uiSagas.openDialogSaga(action)),
    takeEvery(actionTypes.GET_TYPEHINT, (action: any) => uiSagas.getTypeHintSaga(action)),
    // takeEvery(actionTypes.CLOSE_DIALOG, uiSagas.closeDialogSaga),
    // takeEvery(actionTypes.TOGGLE_MENU, uiSagas.toggleMenuSaga)
  ]);
}

export function* watchMarketplace() {
  yield takeEvery(actionTypes.SELL_ITEM, marketplaceSagas.sellItemSaga);
  yield takeEvery(actionTypes.CANCEL_MARKET_ITEM, marketplaceSagas.cancelItemSaga);
  yield takeEvery(actionTypes.BUY_ITEM, marketplaceSagas.buyItemSaga);
}
